import { ClaimDetailMeeting } from '@/components/Domains/Claims/Views/ClaimDetailMeeting'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/meetings_/new')({
  component: ClaimDetailMeeting,
})
